'use strict';

var abSlider = require('core/components/slider');
var productTile = require('client_core/components/productTile');
var toastHelpers = require('core/components/toast');
function addProduct(data) {
  var uuid = data.uuid || null;
  var pid = data.pid || null;
  var addProductUrl = data.action || null;
  var productName = data.name || null;
  $.spinner().start();
  $.ajax({
    url: addProductUrl,
    method: 'POST',
    dataType: 'json',
    data: {
      pid: pid,
      uuid: uuid,
      name: productName
    },
    success: function success(response) {
      var alertType = response.success ? 'success' : 'warning';
      toastHelpers.methods.show(alertType, response.msg, false);
      _updateCartData();
    },
    error: function error(_error) {
      console.error('Save For Later Failed:', _error);
      $.spinner().stop();
    }
  });
}
function removeProduct(data, skipMsg) {
  var uuid = data.uuid || null;
  var pid = data.pid || null;
  var removeProductUrl = data.action || null;
  var productName = data.name || null;
  $.ajax({
    url: removeProductUrl,
    method: 'GET',
    dataType: 'json',
    data: {
      pid: pid,
      uuid: uuid,
      name: productName
    },
    success: function success(response) {
      if (!skipMsg) {
        var alertType = response.success ? 'success' : 'warning';
        toastHelpers.methods.show(alertType, response.msg, false);
      }
      _updateCartData();
    },
    error: function error(_error2) {
      console.error('Remove From Save For Later Failed:', _error2);
      $.spinner().stop();
    }
  });
}
function moveToCart(data) {
  var uuid = data.uuid || null;
  var pid = data.pid || null;
  var addToCartUrl = data.action || null;
  var productName = data.name || null;
  $.spinner().start();
  $.ajax({
    url: addToCartUrl,
    method: 'POST',
    dataType: 'json',
    data: {
      pid: pid,
      uuid: uuid,
      name: productName,
      quantity: 1
    },
    success: function success(response) {
      var alertType = response.error ? 'warning' : 'success';
      toastHelpers.methods.show(alertType, response.message, false);
      if (response.error === false) {
        $('.empty-cart-content').hide();
        data.action = data.removeaction;
        removeProduct(data, true);
        abSlider.initializeSliders($parsedHtml.body);
        productTile.init($parsedHtml.body);
      }
    },
    error: function error(_error3) {
      console.error('Add To Cart Failed:', _error3);
      $.spinner().stop();
    }
  });
}
function _updateCartData() {
  var $cartContainer = $('#cartProductListContainer');
  var updateUrl = $cartContainer.data('update-url');
  $.spinner().stop();
  $.spinner().start();
  $.ajax({
    url: updateUrl,
    method: 'GET',
    dataType: 'html',
    success: function success(response) {
      var $parsedHtml = $(response);
      var cartListHtml = $parsedHtml.find('#cartProductListContainer').html();
      $cartContainer.html(cartListHtml);

      // Update Save For Later
      var saveForLaterListHtml = $parsedHtml.find('#saveForLaterContainer').html();
      var saveForLaterListHtmlTest = $parsedHtml.find('#saveForLaterContainer .slider');
      $('#saveForLaterContainer').html(saveForLaterListHtml);

      // Update classes for page
      var cartPageClasses = $parsedHtml.find('.cart-page').attr('class');
      $('.cart-page').attr('class', cartPageClasses);

      // Update Totals
      var cartRightRailHtml = $parsedHtml.find('.cart-page .order-total-summary').html();
      $('.cart-page .order-total-summary').html(cartRightRailHtml);

      //Update Mobile Totals
      var desktopTotals = $parsedHtml.find('.grand-total-sum').html();
      $('.grand-total-mobile').html(desktopTotals);

      // Update Mini Cart Counter
      var miniCartIconHtml = $parsedHtml.find('.minicart .minicart-quantity').html();
      $('.minicart .minicart-quantity').html(miniCartIconHtml);

      // get the product count from the mini cart markup...
      var cartItemCount = Number($parsedHtml.find('.minicart .minicart-quantity').text());
      // Show empty cart
      if (cartItemCount === 0) {
        // see if we've already set things

        if (!$('.totals-card').hasClass('d-none')) {
          $('.totals-card').addClass('d-none');
          $('.promo-code-card').hide();
          // disable  the checkout btn
          $('.checkout-btn').addClass('disabled');
          // hide  the paypal button, and additional payment buttons..
          $('.cartAdditionalPaymentButtons').addClass('d-none');
        }
      } else {
        // see if we've already set things
        if ($('.totals-card').hasClass('d-none') || $('.totals-card').css('display') === 'none') {
          $('.totals-card').removeClass('d-none').css('display', '');
          $('.promo-code-card').show();
          // enable the checkout btn
          $('.checkout-continue').show();
          $('.checkout-btn').removeClass('disabled');
          // show the paypal button
          $('.cartAdditionalPaymentButtons').removeClass('d-none');
        }
      }
      // paypal.Reinitialize();
      $.spinner().stop();

      // fire event
      $('body').trigger('cart:saveforlater:update');
      abSlider.initializeSliders($parsedHtml.body);
      productTile.init($parsedHtml.body);
    },
    error: function error(_error4) {
      console.error(_error4);

      // paypal.Reinitialize();
      $.spinner().stop();
    }
  });
}
module.exports = {
  saveProductForLater: function saveProductForLater() {
    $('body').on('click', '.save-for-later-btn', function (e) {
      e.preventDefault();
      addProduct($(this).data());
    });
  },
  removeProductSavedForLater: function removeProductSavedForLater() {
    $('body').on('click', '.remove-save-for-later-btn', function (e) {
      e.preventDefault();
      removeProduct($(this).data());
    });
  },
  addToCartSavedForLater: function addToCartSavedForLater() {
    $('body').on('click', '.move-to-cart-save-for-later-btn', function (e) {
      e.preventDefault();
      moveToCart($(this).data());
    });
  },
  updateCartData: function updateCartData() {
    $('body').on('cart:updateData', _updateCartData);
  }
};